<template>
  <div class="app-main-index">
    <div class="bx">
      <keep-alive>
        <components :is="navData[navActiveIndex].com"></components>
      </keep-alive>
    </div>

  </div>
</template>

<script>
import trade from "./components/trade.vue";

export default {
  components: { trade, },
  data() {
    return {
      navActiveIndex: sessionStorage.getItem("app_navActiveIndex") || 0,
      navData: [
        {
          name: "Trade",
          com: "trade",
        },

      ],
    };
  },
  watch: {
    navActiveIndex() {
      sessionStorage.setItem("app_navActiveIndex", this.navActiveIndex);
    },
  },
};
</script>

<style lang="less" scoped>
.bx {
  width: 351px;
  margin: 0 auto;
}

.app-main-index {
  padding-bottom: 44px;
  min-height: 100vh;
  background: #0b0a09;

  .bottom-nav {
    width: 375px;
    // height: 44px;
    position: fixed;
    bottom: 0;
    left: 0;
    background: #1a1f1b;
    display: flex;

    .list {
      // width: 75px;
      flex: 1;
      // height: 44px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 8px 0;

      // .img {
      //   width: 18px;
      //   height: 18px;
      img {
        width: 18px;
        height: 18px;
        margin-bottom: 2px;
      }

      // }
      .text {
        font-family: Inter;
        font-size: 12px;
        transform: scale(0.83);
        font-weight: 500;
        color: #b5b5b5;
      }
    }
  }
}</style>